export const whatPeopleSayData = [
  {
    id: 1,
    content: `<div>
    This motorcycle company in Nepal delivered an epic journey through stunning landscapes. The team's passion and knowledge turned the ride into an unforgettable odyssey, and I can't wait to hit the road with them again!”</div>`,
    name: 'Babita Shrestha',
  },
  {
    id: 2,
    content: `<div>Navigating challenging terrains, our guide Sujan ensured a thrilling yet secure experience. For adrenaline and caution in perfect harmony, this company is the ultimate choice for a motorcycle adventure in Nepal.</div>
       `,
    name: 'Shraya Amatya',
  },
  {
    id: 3,
    content: `<div>Sudin's photographic eye added an artistic touch to our ride, capturing the essence of Nepal's beauty. The dream team transformed a simple motorcycle journey into a visual and cultural masterpiece.</div>
      `,
    name: 'Sagar Amatya',
  },
];

// export const whatPeopleSayData = [
//   {
//     id: 1,
//     content: `<div>
//         <span>“Life is a joke, if you’re not laughing you’re not living”</span>
//         <br />
//         <br />
//         <span>
//           Sudin's been juggling with bipolar disorder for over 15 years now, but
//           guess what? He's basically the ninja of mental health battles. He's
//           like, "Hey, bipolar, I see you, but I'm cooler than an ice cream cone
//           in Antarctica." Now, as you venture into the northern mountains with
//           him, he might go all philosopher on you. Don't panic; it's just his
//           superpower kicking in. And the best part? Even when life decides to
//           play a game of limbo and things go a bit south, Sudin's got this
//           magical ability to keep the laughter flowing. Consider him your
//           personal happiness wizard on two wheels!
//         </span>
//       </div>`,
//     name: 'Sudin - The Joker',
//   },
//   {
//     id: 2,
//     content: `<div>“Life is a ….. I’ll get back to you on that, godda think of about that one”</div>
//       <br />
//       <br />
//       Sujan decided to conquer the world, but guess what? The world hit back harder than a rubber ball in a squash match, and it did it not once, not twice, but enough times to make even action movie heroes go, "Dude, take it easy!" If you ever think your life is a rollercoaster, just sit down with Sujan and let him spill the beans. His tales are like the superhero origin story you never knew you needed – they'll make you want to wear a cape to breakfast.
//       <br />
//       <br />
//       Now, here's the fun part: Sujan might be a tad on the shy side. So, when you meet him, bring your A-game on breaking the ice. Maybe tell a joke or two, or do a magic trick – who knows, he might even share some top-secret survival tips from his epic life adventures!
//       `,
//     name: 'Sujan - The Responsible Guy',
//   },
//   {
//     id: 3,
//     content: `<div>“I can’t help that you suck at your job, just get better”</div>
//       <br />
//       <br />
//       Meet our Miss Marketing genius, the brains behind getting the word out – and trust us, without her, we'd probably be sending smoke signals to communicate. She's not just real; she's like reality TV level real. No beating around the bush here. This girl's a straight shooter; she'll call you out quicker than you can say "adventure." Think you're right? Well, she's got evidence ready to drop on you like a mic at a rap battle. So, buckle up, because with her, it's a no-nonsense, evidence-backed joyride!
//       `,
//     name: 'Sasha - Not a Bullshitter',
//   },
//   {
//     id: 4,
//     content: `<div>“I make the people here look good online”</div>
//       <br />
//       <br />
//       So, turns out, we're not the best when it comes to bragging about ourselves. But fear not! Enter Bhumi, the talking guru of the team. This girl loves to chat so much; we're thinking of nominating her for the "World's Most Talkative" award. Forget about honing your speaking skills; with Bhumi around, you'll become a pro listener in no time. Her outlook on life is so bright; it's basically a portable sun. Hang out with her, and you'll start seeing the world as this glittery, joy-filled wonderland. Who knew talking about ourselves could be this much fun, right?
//       `,
//     name: 'Bhumi - Social Butterfly ',
//   },
//   {
//     id: 5,
//     content: `<div>“Money makes the world go round, just here to make some money and bounce”</div>
//       <br />
//       <br />
//       Meet Nischal, our resident numbers whisperer. Seriously, this guy understands digits like they're telling him their life stories. Got a wild business idea? Well, buckle up because Nischal is here to give it a reality check. He's like the financial Gandalf – you shall not pass without making sense with your numbers! And yeah, he pulled the same stunt with us, but guess what? We owe him one because now our dreams actually have a chance of not going bankrupt. Cheers to the number guru!
//       `,
//     name: 'Nischal - The Money Man',
//   },
//   {
//     id: 6,
//     content: `<div>“Make sure you check everything before you go on tours, it’s a crazy road out there”</div>
//       <br />
//       <br />
//       Say hello to Buddha dai, our motorcycle enthusiast who practically has motor oil running through his veins. He's not just a rider; he's the MacGyver of bikes. Fixing them, customizing them, and if you catch him in the garage, probably disassembling them just for kicks because, you know, curiosity killed the cat, but it never killed Buddha dai's vibe. Before and during the ride, he's the guardian angel of our machines, making sure they're purring like content kittens and not hissing like drama queens. Because when Buddha dai's in charge, our bikes are ready to roll, and he's ready to rock!
//       `,
//     name: 'Buddha workshop - They get shit done',
//   },
// ];
